import './custom-size-guide.js';
import { QuickAddComponent } from './quick-add.js';

/** Reuse Horizon's fetch, variant picker, cart form and modal lifecycle. */
class CustomCollectionActions extends QuickAddComponent {
  static requestSequence = 0;

  get productPageUrl() { return this.dataset.productUrl || super.productPageUrl; }

  handleClick = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (this.hasAttribute('aria-busy')) return;
    const url = this.productPageUrl;
    if (!url) return;
    if (this.dataset.usesSellingPlans === 'true') {
      window.location.assign(url);
      return;
    }
    this.setAttribute('aria-busy', 'true');
    const requestSequence = ++CustomCollectionActions.requestSequence;
    const trigger = event.currentTarget instanceof HTMLButtonElement ? event.currentTarget : event.target.closest('button');
    try {
      const html = await this.fetchProductPage(url);
      if (requestSequence !== CustomCollectionActions.requestSequence) return;
      const grid = html?.querySelector('[data-product-grid-content]');
      if (!grid) throw new Error('Product content unavailable');
      const content = grid.cloneNode(true);
      // Ring sizes must survive the native mobile simplification and remain
      // inside the form when its variant is updated by Section Rendering.
      const ringSize = content.querySelector('.product-ring-size');
      const form = content.querySelector('product-form-component form');
      if (ringSize && form) form.prepend(ringSize);
      const detailsLink = this.querySelector('.custom-collection-actions__fallback')?.cloneNode(true);
      if (detailsLink && form) {
        detailsLink.removeAttribute('hidden');
        detailsLink.className = 'custom-collection-details-link';
        form.append(detailsLink);
      }
      const carousel = content.querySelector('.product-information__media slideshow-container');
      const arrowTemplate = this.querySelector('template.custom-collection-actions__arrows');
      if (carousel && arrowTemplate && !carousel.querySelector('slideshow-arrows')) {
        carousel.append(arrowTemplate.content.cloneNode(true));
      }
      await this.updateQuickAddModal(content);
      const dialog = document.getElementById('quick-add-dialog');
      const modal = dialog?.querySelector('dialog');
      modal?.classList.add('custom-collection-modal');
      modal?.setAttribute('aria-label', this.dataset.productTitle || '');
      const summaryText = this.querySelector('template.custom-collection-actions__summary')?.content.textContent?.trim();
      if (summaryText && !window.matchMedia('(max-width: 749px)').matches) {
        const summary = document.createElement('p');
        summary.className = 'custom-collection-summary';
        summary.textContent = summaryText;
        dialog?.querySelector('.view-product-title')?.after(summary);
      }
      // showDialog opens on the next frame; native dialog can restore this trigger.
      if (trigger) trigger.focus({ preventScroll: true });
      dialog?.showDialog();
      this.querySelector('.custom-collection-actions__fallback')?.setAttribute('hidden', '');
    } catch (error) {
      if (error?.name !== 'AbortError') {
        const fallback = this.querySelector('.custom-collection-actions__fallback');
        fallback?.removeAttribute('hidden');
        fallback?.focus();
      }
    } finally {
      this.removeAttribute('aria-busy');
    }
  };

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.#stopCardNavigation);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.#stopCardNavigation);
  }

  #stopCardNavigation = (event) => {
    if (event.target.closest('button')) event.stopPropagation();
  };
}

if (!customElements.get('custom-collection-actions')) {
  customElements.define('custom-collection-actions', CustomCollectionActions);
}

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.matches('.custom-collection-modal .product-ring-size__option input')) return;
  const output = input.closest('.product-ring-size')?.querySelector('output');
  if (output) output.textContent = input.value;
});
